import { useState } from 'react';
import { OrderSortConfig } from '../components/display/OrdersList';

export const useOrderSorting = () => {
    const [sortConfig, setSortConfig] = useState<OrderSortConfig>({
        field: 'date',
        direction: 'desc'
    });

    return {
        sortConfig,
        setSortConfig
    };
}; 